import { render, staticRenderFns } from "./CardholderGroup.vue?vue&type=template&id=2b2e275b&scoped=true"
import script from "./CardholderGroup.vue?vue&type=script&lang=js"
export * from "./CardholderGroup.vue?vue&type=script&lang=js"
import style0 from "./CardholderGroup.vue?vue&type=style&index=0&id=2b2e275b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b2e275b",
  null
  
)

export default component.exports